import { useEffect, useRef, useState } from 'react';
import styles from 'styles/modules/popUps/Uploader.module.scss';

export default function UploaderDragAndDrop(props) {
    const dropRef = useRef(null);
    const [dragging, setDragging] = useState(false);
    let dragCounter = 0;

    const { style, className } = props;

    const handleDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };
    const handleDragIn = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter++;
        if (e.dataTransfer.items && e.dataTransfer.items.length > 0) {
            setDragging(true);
        }
    };
    const handleDragOut = (e) => {
        e.preventDefault();
        e.stopPropagation();
        dragCounter--;
        if (dragCounter < 1 && dragging) {
            setDragging(false);
        }
    };
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setDragging(false);

        if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
            props.handleDrop(e.dataTransfer.files);
            e.dataTransfer.clearData();
            dragCounter = 0;
        }
    };

    useEffect(() => {
        const div = dropRef.current;
        div.addEventListener('dragenter', handleDragIn);
        div.addEventListener('dragleave', handleDragOut);
        div.addEventListener('dragover', handleDrag);
        div.addEventListener('drop', handleDrop);

        // return () => {
        //     const div = dropRef.current;
        // div.removeEventListener('dragenter', handleDragIn);
        // div.removeEventListener('dragleave', handleDragOut);
        // div.removeEventListener('dragover', handleDrag);
        // div.removeEventListener('drop', handleDrop);
        // };
    }, []);

    return (
        <div
            ref={dropRef}
            style={style}
            className={[className, dragging ? styles.dropActive : ''].join(' ')}
        >
            {dragging && <div className={styles.dropBorder} />}
            {props.children}
        </div>
    );
}
